<template>
  <div class="manage-list-box">
    <template>
      <div class="manage-list-tit clearfix">
        <h2>
          {{ comDatas.comname }}
        </h2>
        <manage-org :com-datas="comDatas" />
      </div>
      <div class="create-org-time">
        创建于 {{ $moment(comDatas.addtime * 1000).format('YYYY-MM-DD') }}
      </div>
      <div class="project-total">
        <span>项目数量：</span>
        {{ comDatas.projectNum }}
        <span>组织成员：</span>
        {{ comDatas.organizeUsers }}
      </div>
      <div class="manage-list-tab">
        <a-tabs
          v-model="activeName"
          v-fixed="{fixed, top, paddingWidth: 1}"
          :animated="false"
          @change="handleClick"
        >
          <a-tab-pane
            key="person"
            tab="成员管理"
          />
          <a-tab-pane
            key="OrgProjects"
            tab="项目管理"
          />
          <a-tab-pane
            v-if="!$isDingDing"
            key="qwdd"
            :tab="qwDingTit"
          />
          <a-tab-pane
            v-if="isCloud"
            key="cloud"
            :tab="privateCloudTit"
          />
        </a-tabs>
        <router-view />
      </div>
    </template>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import ManageOrg from './index/manageOrg/ManageOrg.vue'
import { fixed } from '@/lib/directives'

export default {
  name: 'ManageList',
  components: {
    ManageOrg
  },
  directives: { fixed },
  data () {
    return {
      activeName: 'person',
      LinkPath: '',
      top: 0,
      fixed: true
    }
  },
  computed: {
    ...mapState('organization/org', ['comDatas', 'datasReady']),
    queryData () {
      return this.$route.query
    },
    isCloud () {
      return this.comDatas.private_cloud_status * 1 // this.$store.getters.mixDomain
    },
    qwDingTit () {
      return this.$t('message["720"]')
    },
    personMTit () {
      return this.$t('message["931"]')
    },
    privateCloudTit () {
      return this.$t('message["1148"]')
    },
    baseInfo () {
      const { baseinfo = {} } = this.$store.state
      return baseinfo
    }
  },
  watch: {
    comDatas: {
      handler () {
        const routename = this.$route.name
        let key = 'person'
        let title = this.$t('message["931"]')
        switch (routename) {
          case 'OrgPerson':
            key = 'person'
            title = this.$t('message["931"]')
            break
          case 'OrgQw':
            key = 'qwdd'
            title = this.$t('message["722"]')
            break
          case 'OrgInvite':
            key = 'person'
            title = this.$t('message["1437"]')
            break
          case 'OrgCloud':
            key = 'cloud'
            title = this.$t('message["1148"]')
            break
          case 'OrgProjects':
            key = 'OrgProjects'
            title = '项目管理'
            break
          default:
            key = 'person'
            break
        }
        this.activeName = key
        document.title = title + '-' + this.comDatas.comname
      },
      immediate: true
    }
  },
  async created () {
    const chain = await this.fetchOrgDetail({ cid: this.queryData.cid })
    chain.onSuccess(raw => {
      const isManage = !!raw.isadmin || !!raw.isfounder
      this.setIsManage(isManage)
    })
      .fetch()
  },
  methods: {
    ...mapMutations('organization/org', ['setIsHidden']),
    ...mapMutations(['setIsManage']),
    ...mapActions('organization/org', ['fetchOrgDetail']),
    handleClick (tab) {
      if (tab === 'qwdd') {
        this.LinkPath = '/organization/qw'
      } else if (tab === 'person') {
        this.LinkPath = '/organization/person'
      } else if (tab === 'cloud') {
        this.LinkPath = '/organization/cloud'
      } else if (tab === 'OrgProjects') {
        this.LinkPath = '/organization/projects'
      }
      this.$router.push({
        path: this.LinkPath,
        query: this.queryData
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .manage-list-box::v-deep {
    padding:24px 40px;
    position: relative;

    .manage-list-tit {
     line-height: 56px;
      h2{
        font-weight: 600;
        font-size: 32px;
        font-weight: bold;
        float: left;
      }
      .manage-org-btn {
        float: right;
      }
    }

    .ant-tabs-tab {
      font-size: 18px;
      padding: 12px 0;
    }
    .ant-tabs{
      position: relative;
      overflow: visible;
      padding-top: 65px;
    }
    .ant-tabs-bar{
      background: #fff;
      position: absolute;
      top: 0;
      width: 100%;
      border-top: none !important;
      border-bottom: 1px solid #ebebeb !important;
    }
    .create-org-time {
      color: #b3b3b3;
      font-size: 16px;
      line-height: 40px;
    }
    .project-total {
      line-height: 40px;
      font-size: 16px;
      margin-bottom: 28px;
      span{
        margin-right: 10px;
        color: #666;
      }
      span:nth-child(2){
        margin-left: 40px;
      }
    }
  }
</style>
